<div class="main-wrapper-section">
    <div class="common-header">
        <h3>Sites</h3>
    </div>
    <div class="table-section">
        <div class="card-section">
            <div class="card-panel">
                <div class="table-panel">
                    <div class="table-header">
                        <div class="search-input">
                            <input class="form-control" type="text" (keyup)="search($event.target.value)" placeholder="Search" />
                            <div class="button-group">
                                <button class="cancel-btn" *ngIf="user?.slurpyUserId > 0" (click)="addNewSite()">Add Sites <i class="fa fa-plus"></i></button>
                            </div>
                        </div>
                        <!--<div class="sort-panel">
                          <select class="form-control min-width200" (change)="onChangeSorting($event)">
                            <option value="1">Ascending</option>
                            <option value="2">Descending</option>
                          </select>
                          <i class="fa-solid fa-sliders"></i>
                        </div>-->

                    </div>
                    <form [formGroup]="newSiteForm">
                        <div class="flex-form" style="align-items:center;" *ngIf="showAddNewSite">
                            <div class="form-group">
                                <label>Site</label>
                                <select class="form-control" formControlName="bcmDropDown" (change)="cMSite_Exits($event)">
                                    <option [defaultSelected]=true [value]="-1">--Select Site--</option>
                                    <option *ngFor="let item of bcmDropDown" [value]="item.id">{{ item.text }}</option>
                                </select>
                            </div>
                            <!--<div class="form-group">
                              <label>Team</label>
                              <h6>{{curTeam?.display}}</h6>
                            </div>-->
                            <div class="button-group form-group" style="margin-top:23px">
                                <label></label>
                                <button class="btn cancel-btn" [disabled]="disableBtn" (click)="siteUpdate()">Save<i *ngIf="submitted" class="fas fa-spinner fa-spin"></i></button>
                            </div>
                        </div>
                    </form>
                    <div class="table-body">
                        <table mat-table [dataSource]="dataSource" class="" matSort>
                            <ng-container matColumnDef="siteName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Sites</th>
                                <td mat-cell *matCellDef="let element">
                                    <span  (click)="viewSites(element)" style="cursor:pointer;">
                                        {{element.siteName}}
                                    </span>
                                </td>
                            </ng-container>
                            <!--<ng-container matColumnDef="team">
                              <th mat-header-cell *matHeaderCellDef>Team</th>
                              <td mat-cell *matCellDef="let element">{{element.teamCodeDisplay}}</td>
                            </ng-container>-->
                            <!--<ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let element">
                                    <i class="fa fa-edit"></i>
                                    <i class="fa fa-trash"></i>
                                </td>
                            </ng-container>-->

                            <ng-container matColumnDef="Action">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let element">
                                    <div style="display:flex; justify-content:flex-end">
                                        <div *ngIf="element?.contractCounts==0 && user?.slurpyUserId>0">
                                            <button class="primary-btn-delete" data-toggle="modal" data-target="#deleteSiteModal" (click)="openSiteDltConfirm(element)">
                                                Delete
                                            </button>
                                        </div>
                                        <div class="margin-left15">
                                            <button class="btn-primary" (click)="viewSites(element)">View</button>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)" [ngClass]="{'selected-row': selectedRowIndex == row.sn}"></tr>
                        </table>
                        <!-- <mat-paginator *ngIf="sites?.length > 0" [length]="sites?.length" [pageSizeOptions]="[5, 10, 15, 50]"></mat-paginator> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!--<div class="loader-body" *ngIf="showSpinner">
  <div class="lds-ripple"><div></div><div></div></div>
</div>-->

<div id="deleteSiteModal" class="modal fade" role="dialog" data-backdrop="static">
    <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Confirmation </h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <h6 class="modal-title">Are you sure you want to delete this site <b>{{selectedSite?.siteName}}</b>?</h6>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-success" (click)="onDeleteSite()">Confirm</button>
                <button type="button" class="btn btn-cancel" data-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>


